import * as nodeUtils from "../../../abstract/controller/utils/nodeUtils";
import * as uuidUtils from "../../../abstract/controller/utils/uuidUtils";
import styles from "./ReadOnlyChoiceContainer.module.scss";

function ReadOnlyChoiceContainer({ node, children }) {
  const _uuid = nodeUtils.getUUID(node);
  const _c_uuid = uuidUtils.getContainerUuid(_uuid);

  return (
    <div id={_c_uuid} className={styles["container"]}>
      {children}
    </div>
  );
}

export default ReadOnlyChoiceContainer;
